import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const GENUS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Genus.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Genus.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const GENUS_CONFIG = {
  entityName: 'Genus',
  localizationKey: 'Planning::Entity.Genus',
  fields: GENUS_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.Genuses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
